import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// Every variant of one product, in a single response - `Product.variants` on a product addressed
// by id is the one connection Shopify exempts from its 250 page ceiling, so there is no cursor to
// follow. A listing ships only the first few and links here for the rest.
function* getShopifyProductVariants({ payload: { productId, signal, onSuccess, onError } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.product_variants,
      params: { product_id: productId },
      signal
    });

    yield put(actions.getShopifyProductVariantsDone({ productId, variants: data.results }));
    onSuccess && onSuccess(data.results);
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyProductVariantsFailed,
      endpoint: api.shopify.product_variants.url
    });
    onError && onError(error);
  }
}

export const getShopifyProductVariantsSaga = takeEvery(types.GET_SHOPIFY_PRODUCT_VARIANTS_REQUEST, getShopifyProductVariants);
